function getXhr () {
  try {
    return new window.XMLHttpRequest()
  } catch (e) {
    try {
      return new window.ActiveXObject('Msxml2.XMLHTTP')
    } catch (e) {
      return new window.ActiveXObject('Microsoft.XMLHTTP')
    }
  }
}

function get ({url, headhers, xhr, data, method}, cb) {
  let xhrObj = xhr ? xhr() : getXhr()
  xhrObj.onreadystatechange = function () {
    if (xhrObj.readyState !== 4) return
    cb(xhrObj.status !== 200 ? `xhrObj: server response status is ${xhrObj.status}` : false, xhrObj.responseText)
  }
  xhrObj.open(method && method.toUpperCase() || 'GET', url, true)
  if (!(data instanceof window.FormData)) {
    xhrObj.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=UTF-8')
  }
  headhers && Object.keys(headhers).forEach(key => {
    xhrObj.setRequestHeader(key, headhers[key])
  })
  xhrObj.send(data || null)
}
const axios = options => {
  return new Promise((resolve, reject) => {
    get(options, (err, data) => {
      if (err) reject(err)
      try {
        const json = JSON.parse(data)
        resolve({data: json})
      } catch (err) {
        reject(err)
      }
    })
  })
}
['get', 'post'].forEach(method => {
  axios[method] = (url, params) => {
    return new Promise((resolve, reject) => {
      get({
        method,
        url,
        data: params
      }, (err, data) => {
        if (err) reject(err)
        try {
          const json = JSON.parse(data)
          resolve({data: json})
        } catch (err) {
          reject(err)
        }
      })
    })
  }
})
export default axios



// WEBPACK FOOTER //
// ./src/assets/js/api.js